export const CREATE_COUPON = 'CREATE_COUPON';
export const FETCH_COUPONS = 'FETCH_COUPONS';
export const UPDATE_COUPON = 'UPDATE_COUPON';
export const DELETE_COUPON = 'DELETE_COUPON';
